import React, { useEffect } from 'react';
import { Box, FormControlLabel, MenuItem, Radio } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { useListPaymentMethodsQuery } from 'renderer/features/settings/services/paymentMethods.endpoints';
import { TextField } from 'formik-mui';
import MainCard from './MainCard';

interface ExistingPaymentMethodsForm {
  isNewPaymentMethod: boolean;
  existingPaymentMethodToken: string;
}

const ExistingPaymentMethods = ({ category }: { category: string }) => {
  const { data: paymentMethods } = useListPaymentMethodsQuery(category);
  const { values, setFieldValue } =
    useFormikContext<ExistingPaymentMethodsForm>();

  // When the payment methods load, automatically select the default
  useEffect(() => {
    if (paymentMethods) {
      const defaultCard = paymentMethods.find((card) => !!card.default);
      setFieldValue(
        'existingPaymentMethodToken',
        defaultCard?._id ?? paymentMethods[0]?._id ?? '',
      );
    }
  }, [category, paymentMethods, setFieldValue]);

  return (
    <MainCard>
      {' '}
      <FormControlLabel
        control={
          <Radio
            checked={!values.isNewPaymentMethod}
            onChange={(e) =>
              setFieldValue('isNewPaymentMethod', !e.target.checked)
            }
            value="existingCard"
          />
        }
        label="Existing Credit Cards"
        labelPlacement="end"
      />
      {/* <Box sx={getCardStyles('existingCard')}> */}
      <Box
        sx={{
          opacity: !values.isNewPaymentMethod ? 1 : 0.4,
          pointerEvents: !values.isNewPaymentMethod ? 'auto' : 'none',
        }}
      >
        {/* <InputLabel id="existing-card-label">
                            Select Card
                          </InputLabel> */}
        {paymentMethods && (
          <Field
            component={TextField}
            fullWidth
            select
            size="small"
            id="existingPaymentMethodToken"
            name="existingPaymentMethodToken"
            labelId="existing-card-label"
            label="Select Card"
          >
            {paymentMethods.map((card) => (
              <MenuItem key={card._id} value={card._id}>
                {`${card.cardType} ending in ${card.last4}`}
              </MenuItem>
            ))}
          </Field>
        )}
      </Box>
    </MainCard>
  );
};

export default ExistingPaymentMethods;
